import React, { useState, useEffect } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, c as _slicedToArray } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_arrayReduce-35053fa6.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import { _ as _isFunction } from './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './reduce-359d9da9.js';
import './index-7f6959fc.js';
import { L as Label } from './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import { _ as _noop } from './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import './Typographies.js';
import './index-f96168ba.js';
import { _ as _isNull, a as _isUndefined } from './isNull-db706d68.js';
import { c as chain } from './chain-d06384bf.js';
import { g as getSpacesAsCss } from './getSpacesAsCSS-2c03c4c1.js';
import './_hasUnicode-6e5e26e7.js';
import Input from './Input.js';
import { isDate, getHours, getMinutes, getSeconds, setHours, setMinutes, setSeconds } from 'date-fns';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  padding: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTimeContainer = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return getSpacesAsCss(theme.components.inputTime.spaces, 'padding');
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A select field.
 *
 */

var InputTime = function InputTime(_ref) {
  var hoursLabel = _ref.hoursLabel,
      minutesLabel = _ref.minutesLabel,
      secondsLabel = _ref.secondsLabel,
      datePartRender = _ref.datePartRender,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["hoursLabel", "minutesLabel", "secondsLabel", "datePartRender", "defaultValue", "value", "onChange"]);

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1]; // Sync with value if in controlled state


  useEffect(function () {
    if (isDate(value)) {
      setStateValue(value);
    }
  }, [value]);

  var handleOnChange = function handleOnChange(value, mutator) {
    var newDate = mutator(stateValue, value);
    setStateValue(newDate);
    onChange(newDate);
  };

  var defaultComponentRender = function defaultComponentRender(mode, label, value, handleOnChange) {
    return React.createElement(Label, null, label, React.createElement(Input, {
      type: "number",
      min: "0",
      max: mode === 'hours' ? '24' : '60',
      value: value,
      onChange: function onChange(e) {
        return handleOnChange(e.target.value);
      }
    }));
  };

  var chainedComponentRender = function chainedComponentRender() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    return chain(function (element) {
      return !_isNull(element) && !_isUndefined(element);
    }, function () {
      return datePartRender && _isFunction(datePartRender) && datePartRender.apply(void 0, params);
    }, function () {
      return defaultComponentRender.apply(void 0, params);
    });
  };

  return React.createElement(StyledTimeContainer, rest, chainedComponentRender('hours', hoursLabel, getHours(stateValue), function (value) {
    return handleOnChange(value, setHours);
  }), chainedComponentRender('minutes', minutesLabel, getMinutes(stateValue), function (value) {
    return handleOnChange(value, setMinutes);
  }), chainedComponentRender('seconds', secondsLabel, getSeconds(stateValue), function (value) {
    return handleOnChange(value, setSeconds);
  }));
};

InputTime.defaultProps = {
  hoursLabel: 'Hours',
  minutesLabel: 'Minutes',
  secondsLabel: 'Seconds',
  defaultValue: new Date(),
  value: null,
  onChange: _noop,
  datePartRender: null
};
InputTime.propTypes = {
  hoursLabel: PropTypes.string,
  minutesLabel: PropTypes.string,
  secondsLabel: PropTypes.string,
  datePartRender: PropTypes.func,
  defaultValue: PropTypes.instanceOf(Date),
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func
};
/** @component */

var index = styled(React.memo(InputTime))(_templateObject$1());

export default index;
